import { render, staticRenderFns } from "./PlacementGroupPersonContacts.vue?vue&type=template&id=41a2220c&"
import script from "./PlacementGroupPersonContacts.vue?vue&type=script&lang=ts&"
export * from "./PlacementGroupPersonContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports